import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './plugins/animations'
import './plugins/interactive'
import './plugins/games'
import MobileAdapter from './plugins/mobileAdapter'
import applyMobileOptimizations from './plugins/applyMobileOptimizations'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 初始化移动端适配
MobileAdapter.init()

// 应用移动端优化
applyMobileOptimizations()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
